import { useState } from "react";
import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  const [showAll, setShowAll] = useState(false);
  const displayedCategories = showAll ? categories : categories.slice(0, 9);

  return (
    <section id="categorias" className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full border border-accent-200 text-accent-700 text-xs font-medium mb-4">
            Categorias
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3">
            Categorias de Produtos
          </h2>
          <p className="text-foreground-500 text-base max-w-lg mx-auto">
            Explore todas as categorias disponíveis na nossa planilha CSSBuy. Clique em qualquer categoria para ver os produtos no site principal.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {displayedCategories.map((cat) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative rounded-xl overflow-hidden aspect-square cursor-pointer"
            >
              {/* Image */}
              <img
                src={cat.image}
                alt={`CSSBuy Spreadsheet - ${cat.name}`}
                title={`CSSBuy Spreadsheet ${cat.name}`}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              {/* Gradient overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              {/* Content */}
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <h3 className="text-background-50 font-heading text-xl font-semibold mb-1">
                  {cat.name}
                </h3>
                <p className="text-background-50/70 text-sm flex items-center gap-1">
                  Ver produtos
                  <i className="ri-arrow-right-up-line text-xs"></i>
                </p>
              </div>
            </a>
          ))}
        </div>

        {/* Show more button */}
        {categories.length > 9 && (
          <div className="text-center mt-8">
            <button
              onClick={() => setShowAll(!showAll)}
              className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full border-2 border-foreground-300 text-foreground-700 font-medium text-sm cursor-pointer hover:border-foreground-500 hover:text-foreground-950 transition-colors whitespace-nowrap"
            >
              {showAll ? "Mostrar Menos" : `Ver Todas as ${categories.length} Categorias`}
              {showAll ? <i className="ri-arrow-up-s-line text-base"></i> : <i className="ri-arrow-down-s-line text-base"></i>}
            </button>
          </div>
        )}
      </div>
    </section>
  );
}